import script from "./NotificationViewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationViewDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationViewDialog.vue?vue&type=style&index=0&id=7fb6d0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb6d0a6"]])

export default __exports__